import styled from 'styled-components';

export const Wrapper = styled.form`
  width: 500px;
  background: #fff;
  border: 1px solid #c1c1c1;
  margin: 20px auto 0;
  border-radius: 5px;
  box-shadow: 3px 3px 2px #afafaf;
  box-sizing: border-box;
  @media (max-width: 620px) {
    width: 100%;
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
`;

export const Spinner = styled.div`
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 5px solid rgb(3, 3, 3);
  border-radius: 50%;
  border-top-color: rgba(0, 0, 0, 0);
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;

export const UserDetailBlockWrap = styled.div`
  width: 500px;
  display: flex;
  justify-content: space-around;
  font-size: 18px;
  padding-top: 15px;
  @media (max-width: 670px) {
    width: 100%;
  }
`;
export const GoalsBlock = styled.div`
  width: 200px;
  @media (max-width: 620px) {
    width: 80%;
  }
`;

export const ParametersBlock = styled.div`
  width: 250px;
  @media (max-width: 620px) {
    width: 100%;
    margin: 0 auto;
  }
`;

export const DetailBlock = styled.div`
  text-align: left;
  padding: 0 30px;
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
`;

export const DetailBlockInput = styled.input`
  margin-left: auto;
  border: none;
  display: inline-block;
  width: 60px;
  font-size: 16px;
  text-align: center;
  background: url(${(props) => props.image}) no-repeat right center #fff;
  background-size: 15px;
  &:focus {
    background: #fff;
  }
`;

export const NoUserSelected = styled.div`
  font-size: 15px;
  text-align: center;
  color: #d3d3d3;
  padding: 5px 30px;
`;

export const UserDatah1 = styled.h1`
  font-size: 20px;
  text-align: center;
`;

export const Select = styled.select`
  width: 200px;
  height: 30px;
  background: #fff;
  border-radius: 5px;
  @media (max-width: 500px) {
    width: 100px;
  }
`;

export const Option = styled.option`
  max-width: 200px;
  width: 200px !important;
  word-wrap: break-word;
`;

export const Button = styled.button`
  display: inline-block;
  width: 170px;
  height: 35px;
  background: #157aac;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 20px;
  &:hover {
    background: #4f93c3;
    color: white;
    border: 1px solid #000542;
  }
`;

export const WrapSaveBlock = styled.div`
  margin: 5px;
  display: flex;
  justify-content: center;
`;

export const ValidateUserDataGeneralMessage = styled.div`
  color: red;
  font-size: 12px;
  margin: 3px 0;
  text-align: center;
`;

export const ValidateErrorMessage = styled.div`
  color: red;
  font-size: 10px;
`;

export const WarningMessage = styled.div`
  color: orange;
  font-size: 10px;
`;

export const ParamTitle = styled.div`
  font-size: 15px;
`;



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/UserDetailBlock/StyleUserDetailBlock.jsx